import { render, staticRenderFns } from "./PelletsCurrentPriceSection.vue?vue&type=template&id=5b966ce7&scoped=true"
import script from "./PelletsCurrentPriceSection.vue?vue&type=script&lang=ts"
export * from "./PelletsCurrentPriceSection.vue?vue&type=script&lang=ts"
import style0 from "./PelletsCurrentPriceSection.vue?vue&type=style&index=0&id=5b966ce7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b966ce7",
  null
  
)

export default component.exports